import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API } from '../../app.config';
import { Observable, of } from 'rxjs';
import { TradutorRQ, TradutorRS } from '../../model';
import { map, catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class TradutorService {

  constructor(private http: HttpClient) { }

  TraduzirIA(TradutorRQ: TradutorRQ): Observable<TradutorRS> {
    const headers = new HttpHeaders().set('noloader', 't');
    return this.http.post<any>(`${API}/api/tradutor/traduzir`, TradutorRQ, { headers: headers });
  }

  Traduzir(tradutorRQ: TradutorRQ): Observable<string> {
      let text = tradutorRQ.Conteudo;
      const regex = /(Cancelamento a partir de )(\d{2}\/\d{2}\/\d{4})( multa de 100% do valor da reserva\.)/;
      const match = text.match(regex);
      let date = "";
  
      if (match) {
        date = match[2]; // Captura a data
        tradutorRQ.Conteudo = text.replace(regex, "$1[DATA_REMOVIDA]$3");
      }
  
      return this.TraduzirIA(tradutorRQ).pipe(
        map(dados => {
          let translatedText = dados.Conteudo;
          return translatedText.replace("[DATA_REMOVIDA]", date);
        }),
        catchError(error => {
          console.error("Erro ao traduzir:", error);
          return of("Erro na tradução");
        })
      );
    }

  /**
   * Compara hotéis usando IA e retorna uma análise textual
   * @param hoteis - Lista de hotéis a serem comparados
   * @param perguntaPersonalizada - Pergunta personalizada do usuário (opcional)
   * @param contextoBusca - Contexto da busca com informações de quartos e pessoas (opcional)
   * @param idioma - Idioma da análise (padrão: 'pt-BR')
   * @returns Observable com o texto de análise da IA
   */
  comparaHotelIA(hoteis: any[], perguntaPersonalizada?: string | null, contextoBusca?: any, idioma?: string): Observable<string> {
    const tradutorRQ = new TradutorRQ();
    tradutorRQ.Tipo = 'comparacaoHoteis';
    tradutorRQ.Conteudo = JSON.stringify(hoteis);
    tradutorRQ.LinguaAlvo = idioma || 'pt-BR'; // Define o idioma da análise
    
    // Monta o body da requisição com a pergunta personalizada, contexto e idioma, se existirem
    const body: any = { 
      Hoteis: hoteis,
      LinguaAlvo: idioma || 'pt-BR' // Envia o idioma no body também
    };
    
    if (perguntaPersonalizada && perguntaPersonalizada.trim() !== '') {
      body.PerguntaPersonalizada = perguntaPersonalizada.trim();
    }

    if (contextoBusca) {
      body.ContextoBusca = contextoBusca;
    }
    
    const headers = new HttpHeaders().set('noloader', 't');
    return this.http.post<any>(`${API}/api/tradutor/comparar-hoteis`, body, { headers: headers }).pipe(
      map(response => response.Analise || response.Conteudo || ''),
      catchError(error => {
        console.error("Erro ao comparar hotéis com IA:", error);
        return of("Não foi possível gerar a análise de comparação no momento.");
      })
    );
  }
}
